<p-dialog [headerText]="data.header" [btnConfig]="footerBtnConfig">
    <empty-state [visualSource]="data.emptyStateImageSource" [text]="data.mainMsg">
        <p *ngIf="data.subMsg" class="p-paragraph-1">{{ data.subMsg }}</p>
    </empty-state>
</p-dialog>
